import { api } from '../../core/network/api';
import type { LootRarity } from '../config/item-defs';

/** design/gdd/sconce-hub.md Core Rule #3 — the one genuinely new REST endpoint this GDD adds. */
export interface StashItemRow {
  id: string;
  itemDefId: string;
  weightKg: number;
  rarity: LootRarity;
  insurable: boolean;
  acquiredAt: string;
}

export const listStash = (): Promise<StashItemRow[]> => api.get('/stash');
